import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import reducers from './reducer.js';
import rootSaga from './rootSaga.js';
import { initialState } from './preloadedState.js'
import { routerMiddleware } from 'react-router-redux'; 
import {history} from './history.js'

const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
  reducer: reducers,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ thunk: false, serializableCheck: false }).concat(
      sagaMiddleware,
      routerMiddleware(history) // Agrega el routerMiddleware con tu instancia de history
    ),
  preloadedState: initialState
});

// Run your root saga
sagaMiddleware.run(rootSaga);

export default store;